<template>
  <div>
    <div class="row d-flex align-items-center">
      <div class="col-4">
        <div class="form-group">
          <label for="">{{ $t('ct-custom-sizes') }}</label>
          <select v-model="object.custom" id="" class="form-control">
            <option :value="false">{{ $t('ct-no') }}</option>
            <option :value="true">{{ $t('ct-yes') }}</option>
          </select>
        </div>
      </div>
      <div class="col-8" v-if="type === 'mobile'">
        <button class="btn btn-primary" @click.prevent="$emit('copy')">{{ $t('ct-copy-settings-from-desktop') }}</button>
      </div>
    </div>

    <div v-show="object.custom">

      <h3>{{ $t('ct-div-sizes') }}</h3>
      <div class="row">
        <div class="col-3">
          <div class="form-group">
            <label for="">{{ $t('ct-container-size') }}</label>
            <input type="range" min="50" max="90" step="5"
                   v-model="object.container.width"
                   @mousemove="recalc()"
                   @change="recalc()"
                   class="form-control-range">
            <select name="" id="" @change="recalc()" v-model="object.container.width" class="form-control">
              <option v-for="(opt, idx) in options" :key="idx" :value="opt">{{ opt }}</option>
            </select>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="">{{ $t('ct-button-size') }}</label>
            <input type="range" min="0" max="50" step="5"
                   v-model="object.btnPlace.width"
                   class="form-control-range"
                   disabled>
            <input type="text" readonly class="form-control" v-model="object.btnPlace.width">
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="">{{ $t('ct-padding') }}</label>
            <input type="range" min="0" max="150" step="5"
                   v-model="object.btnPlace.padding"
                   @mousemove="recalc()"
                   @change="recalc()"
                   class="form-control-range">
            <select name="" id="" @change="recalc()" v-model="object.btnPlace.padding" class="form-control">
              <option v-for="(opt, idx) in paddings" :key="idx" :value="opt">{{ opt }}</option>

            </select>
          </div>
        </div>
      </div>

      <h3>{{ $t('ct-fields') }}</h3>

      <div class="row">
        <div class="form-group col-4" v-for="(field, index) in object.fields" :key="index">
          <label for="">{{ $t('ct-field') }} : {{ field.name || field.tag }} </label>
          <select name="" id="" v-model="field.size" class="form-control">
            <option value="col-3">25%</option>
            <option value="col-6">50%</option>
            <option value="col-9">75%</option>
            <option value="col-12">100%</option>
          </select>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {SweetModalTab} from "sweet-modal-vue";

export default {
  name: "ConfigFieldsDevice",
  components: {
    SweetModalTab
  },
  props: ['type', 'object', 'paddings', 'options'],
  methods: {
    recalc() {
      if (this.object.container.width < 50) {
        this.object.container.width = 50
      }
      this.object.btnPlace.width = 100 - parseInt(this.object.container.width);
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/editor/resources/ConfigFieldsDevice.vue